import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-449bc1e8")

_pushScopeId("data-v-449bc1e8")
const _hoisted_1 = { class: "flex justify-between items-center py-4 px-6 border-b border-gray-lp-2100" }
const _hoisted_2 = { class: "text-xl font-semibold text-gray-lp-300" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5 cursor-pointer",
  alt: "x"
}, null, -1)
const _hoisted_4 = { class: "h-full flex flex-col min-h-0 overflow-hidden" }
const _hoisted_5 = { class: "flex flex-col gap-2 py-4 px-6" }
const _hoisted_6 = {
  for: "transfer-area-pilih-area",
  class: "text-gray-lp-300 font-semibold text-sm"
}
const _hoisted_7 = { class: "flex flex-col gap-2 py-4 px-6 border-t border-gray-lp-2100" }
const _hoisted_8 = {
  for: "transfer-area-search",
  class: "text-gray-lp-300 font-semibold text-sm"
}
const _hoisted_9 = { class: "px-6 pb-2 flex-1 min-h-0 flex flex-col" }
const _hoisted_10 = { class: "flex justify-end gap-6 py-4 px-6 border-t border-gray-lp-2100 modal-footer z-50" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_Search = _resolveComponent("Search")!
  const _component_TableTransferArea = _resolveComponent("TableTransferArea")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    modelValue: _ctx.isShowModal,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.isShowModal = $event)),
    customWidth: "w-4/5",
    customHeight: "90vh",
    customBody: "p-0",
    footer: true,
    persistent: true,
    showOverflow: false
  }, {
    header: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t("pickupDashboard.manageArea.transferAreaTitle", {
              areaName: _ctx.data.areaName
            })), 1),
        _createVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowModal = false)),
          class: "flex items-center justify-center w-9 h-9 rounded-full bg-gray-lp-100"
        }, [
          _hoisted_3
        ])
      ])
    ]),
    "main-footer": _withId(() => [
      _createVNode("div", _hoisted_10, [
        _createVNode("button", {
          class: "px-24 py-3 rounded-md text-red-lp-510 border border-red-lp-510 text-sm font-semibold",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShowModal = false))
        }, _toDisplayString(_ctx.$t("pickupDashboard.manageArea.cancel")), 1),
        _createVNode("button", {
          class: ["px-24 py-3 rounded-md text-sm font-semibold text-white", 
            _ctx.isSelectedTransferArea
              ? 'bg-red-lp-300 cursor-pointer'
              : 'bg-gray-lp-600 cursor-not-allowed'
          ],
          disabled: !_ctx.isSelectedTransferArea,
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleConfirmation && _ctx.handleConfirmation(...args)))
        }, _toDisplayString(_ctx.$t("pickupDashboard.manageArea.transfer")), 11, ["disabled"])
      ])
    ]),
    default: _withId(() => [
      _createVNode("section", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("pickupDashboard.manageArea.destinationAreaLabel")), 1),
          _createVNode(_component_SelectSearch, {
            isLoading: _ctx.isLoadingFilter,
            options: _ctx.selectSearchDataDestination,
            keyName: "areaName",
            keyValue: "uid",
            placeholder: 
            _ctx.$t('pickupDashboard.manageArea.destinationAreaPlaceholder')
          ,
            "model-value": _ctx.destinationValue,
            isSelectedNotReset: true,
            useInfiniteScroll: "",
            errorMessage: _ctx.$t('pickupDashboard.manageArea.noDestinationArea'),
            onFilter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSelectSearchDestination($event))),
            onFocus: _ctx.fetchPartnerAreaList,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.onChooseSelectSearchDestination($event))),
            onScrolled: _ctx.fetchPartnerAreaList,
            onClear: _ctx.onCloseSelectSearchDestination
          }, null, 8, ["isLoading", "options", "placeholder", "model-value", "errorMessage", "onFocus", "onScrolled", "onClear"])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("pickupDashboard.manageArea.search")), 1),
          _createVNode(_component_Search, {
            id: "transfer-area-search",
            placeholder: 
            _ctx.$t('pickupDashboard.manageArea.searchSubDistrictPlaceholder')
          ,
            class: "w-full h-9",
            timeout: 300,
            minChar: 3,
            value: _ctx.search,
            onClear: () => _ctx.onSearch(''),
            onEnter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSearch($event.target.value)))
          }, null, 8, ["placeholder", "value", "onClear"])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_TableTransferArea, {
            columns: _ctx.columns,
            tableData: _ctx.paginatedTransferAreaData,
            sortKey: _ctx.sortKey,
            sortOrder: _ctx.sortOrder,
            enableSort: true,
            isLoading: _ctx.isLoadingData,
            pagination: _ctx.pagination,
            startIndex: _ctx.startIndex,
            errorCause: _ctx.errorCause,
            onSetPage: _ctx.onPageChange,
            onSort: _ctx.handleSort,
            onSelectAll: _ctx.handleSelectAll,
            onSelectRow: _ctx.onSelectRow,
            onTryAgain: _ctx.fetchListTransferArea
          }, null, 8, ["columns", "tableData", "sortKey", "sortOrder", "isLoading", "pagination", "startIndex", "errorCause", "onSetPage", "onSort", "onSelectAll", "onSelectRow", "onTryAgain"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
})